export default "__VITE_ASSET__BCzNsjpq__"